const AlbaniaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_110721)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#D80027"
      />
      <path
        d="M31.3045 14.8442H24.0603C24.5074 14.3759 24.7827 13.7419 24.7827 13.0432C24.7827 11.6025 23.6147 10.4346 22.174 10.4346C21.2663 10.4346 20.4674 10.8983 20.0001 11.6015C19.5328 10.8983 18.7338 10.4346 17.8262 10.4346C16.3855 10.4346 15.2175 11.6025 15.2175 13.0432C15.2175 13.7419 15.4928 14.376 15.9399 14.8442H8.6958C8.6958 16.7652 10.369 18.3224 12.2899 18.3224H12.1739C12.1739 20.2435 13.7312 21.8007 15.6523 21.8007C15.6523 22.4229 15.8163 23.0062 16.1025 23.5112L13.2174 26.3964L15.431 28.6099L18.571 25.47C18.6939 25.515 18.8212 25.5512 18.9526 25.5758L17.0552 29.8598L20.0001 33.0432L22.945 29.8596L21.0476 25.5757C21.1791 25.5511 21.3063 25.515 21.4292 25.4698L24.5692 28.6097L26.7828 26.3962L23.8976 23.511C24.1839 23.0061 24.3479 22.4227 24.3479 21.8005C26.2689 21.8005 27.8262 20.2433 27.8262 18.3221H27.7103C29.6312 18.3223 31.3045 16.7652 31.3045 14.8442Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110721">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default AlbaniaSvg;
